import Swiper from "swiper";

export default class SlideCard {
  constructor() {
    this._slider = document.querySelector('.slider--slider-card');

    if (this._slider) {
      this.init()
    }
  }

  init() {
    //get instance swiper
    const swiperInstance = this._slider.swiper;

    let currentSlide = this._slider.querySelector('.swiper-slide-active');
    const title = currentSlide.querySelector('.c-title');
    const content = currentSlide.querySelector('.c-text');
    const heightContent = content.offsetHeight;

    title.style.transform = `translateY(-${heightContent + 20 + 53}px)`;
    content.style.transform = `translateY(-20px)`;
    content.style.opacity = 1;


    swiperInstance.on('slideChangeTransitionEnd', () => {
      let currentSlide = this._slider.querySelector('.swiper-slide-active');
      let otherSlides = this._slider.querySelectorAll('.swiper-slide');

      otherSlides.forEach(slide => {
        if (slide !== currentSlide) {
          const title = slide.querySelector('.c-title');
          const content = slide.querySelector('.c-text');

          title.style.transform = `translateY(0)`;
          content.style.transform = `translateY(0)`;
          content.style.opacity = 0;
        }
      });

      const title = currentSlide.querySelector('.c-title');
      const content = currentSlide.querySelector('.c-text');
      const heightContent = content.offsetHeight;

      title.style.transform = `translateY(-${heightContent + 20 + 53}px)`;
      content.style.transform = `translateY(-20px)`;
      content.style.opacity = 1;

    })

  }

  // card.addEventListener('mouseover', () => {
  //   title.style.transform = `translateY(-${heightContent}px)`;
  //   content.style.transform = `translateX(-20px)`;
  // })
  //
  // card.addEventListener('mouseout', () => {
  //   title.style.transform = `translateY(0)`;
  //   content.style.transform = `translateX(0)`;
  // })
}
